import type {
  DocumentMessagesUpdatedSubscription,
  DocumentMessagesUpdatedSubscriptionVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const DOCUMENT_MESSAGES_UPDATED: TypedDocumentNode<
  DocumentMessagesUpdatedSubscription,
  DocumentMessagesUpdatedSubscriptionVariables
> = gql`
  subscription DocumentMessagesUpdated($documentId: String!) {
    documentMessagesUpdated(documentId: $documentId) {
      documentId
      ownerUserId
    }
  }
`;
